import { Injectable } from '@angular/core';
import { BehaviorSubject,Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly loggedInUserDetails = new BehaviorSubject<any | null>(null);

  private readonly isFTEuser = new BehaviorSubject<boolean>(false);

  public _currentUser = new BehaviorSubject<string | null>(null); // Initial value is null

  public currentUser$: Observable<string | null> = this._currentUser.asObservable();
  private readonly messageSource = new BehaviorSubject<string>('default message');
  currentMessage = this.messageSource.asObservable();

  changeMessage(message: any) {
    this.messageSource.next(message);
  }

   public _currentStatus = new BehaviorSubject<string | null>(null); // Initial value is null

  public currentStatus$: Observable<string | null> = this._currentStatus.asObservable();
  private readonly statusSource = new BehaviorSubject<string>('default status');
  currentStatus = this.statusSource.asObservable();

  changeStatus(status: any) {
    this.statusSource.next(status);
  }

  setLoggedInUserDetails(data: any): void {
    this.loggedInUserDetails.next(data);
  }

  getLoggedInUserDetails(): Observable<any | null> {
    return this.loggedInUserDetails.asObservable();
  }

  setIsFTEuser(value: boolean): void {
    this.isFTEuser.next(value);
  }

  getIsFTEuser(): Observable<boolean> {
    return this.isFTEuser.asObservable();
  }

  getIsFTEuserValue(): boolean {
    return this.isFTEuser.getValue();
  }

}
